module.exports = __webpack_public_path__ + "img/imagen2.7332a224.png";